
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import config from '../../../config'
import Header from '../../Header';
import Footer from '../../Pages/Footer';
import Connectwallet from '../Login/Connect_wallet';
import Google from '../../Pages/Presale/IconBox/Google'
import Thanks from '../Login/Thanks'
// import Selectmethod from './Selectmethod';
import Selectmethod from '../Login/Selectmethod';
import Qrcode from '../Login/Qrcode';
import '../../Pages/css/selectwalletform.css';
import { Container, Row, Col, Card, Button, Form, InputGroup } from 'react-bootstrap';
import * as ACTIONTYPES from '../../../redux/actionTypes'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Spin } from 'antd';
import { ERROR, Success, Warning } from '../../../utils/errors';
import { userlogin } from '../../../services/apiServices';
import { useDispatch } from 'react-redux';
import { FaRegEye } from "react-icons/fa";

const LoadingPopup = () => {
    return (
        <div className="loading-popup-container">
            <div className="loading-popup">
                <p>Please wait</p>
                <h1>Loggin in . . .</h1>
            </div>
        </div>
    );
};

const Selectwalletform = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showLoading, setShowLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [passwordicon, setPasswordicon] = useState(0);

    const submitForm = async (values) => {
        setShowLoading(true)

        const payload = {
            "emailAddress": values.userName,
            "password": values.password
        }
        try {

            const { data: response } = await userlogin(payload)
            setShowLoading(false)
            if (response.status) {
                response.data.isLogin = true;
                dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
                dispatch({ type: ACTIONTYPES.USERLOGIN, payload: response.data, token: response?.data?.accessToken });
                // Success(response.message)
                navigate(`${config.baseurl}`);
            } else {
                Warning(response.message)
            }
        } catch (error) {
            setShowLoading(false)
            console.log('error', error)
            ERROR("Invalid email or password")
        }
    }


    return (
        <>
            {/* <Header /> */}

            <section className="login-section">
                <div className="login-container">
                    <Container fluid className='px-0'>
                        <Row className="justify-content-center">
                            <Col lg={12}>
                                <Row className='align-items-center'>
                                    <Col lg={5} md={5} xs={12} className=''>
                                        <div className="login-form">
                                            <div className="">
                                                <img
                                                    src="assets/images/login/coinsbackImg.svg"
                                                    alt="logo" className='coinsbackImg'
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={7} md={7} xs={12} className=''>
                                        <Spin spinning={showLoading} >
                                            {/* <div className="loginDiv" style={{ minHeight: "368px" }}> */}
                                            <div className="loginDiv">
                                                <Row>
                                                    <Col lg={7} className='mx-auto'>
                                                        <div className='form_content'>
                                                            <Form >
                                                                <div className='formDiv'>
                                                                    <div className='text-center formheadbox'>
                                                                        <h1 className='text-primary fw-bold mb-1'>Select Wallet</h1>
                                                                    </div>
                                                                </div>
                                                                <div className='google_box px-lg-5 px-3'>
                                                                    <Row>
                                                                        <Col lg={12} md={12} className='mt-4 mx-auto px-lg-5'>
                                                                            <div className='mb-4'>
                                                                                <Button variant="" type="button" className='googlebtn w-100'>
                                                                                    <img
                                                                                        src="assets/icons/metamask.svg"
                                                                                        alt=" metamask"
                                                                                        className=" Googleicon me-3" style={{ width: "35px", height: "35px" }}
                                                                                    />
                                                                                    <span>Metamask</span>
                                                                                </Button>
                                                                            </div>
                                                                            <div>
                                                                                <Button variant="" type="button" className='googlebtn w-100'>
                                                                                    <img
                                                                                        src="assets/icons/walleticon.svg"
                                                                                        alt=" walleticon"
                                                                                        className=" Googleicon me-3" style={{ width: "35px", height: "35px" }}
                                                                                    />
                                                                                    <span> Wallet Connect</span>
                                                                                </Button>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </div>
                                                            </Form>

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Spin>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>



                </div>


            </section>

            {/* <Footer /> */}
            {isLoading && <LoadingPopup />}

        </>
    )
}

export default Selectwalletform;
